import { __ } from "@wordpress/i18n";
import { useRulesContext } from "../../../../hook/useRulesContext";
import { useConfirm } from "../../../../hook/useConfirm";
import ControlSearch from "./controls/ControlSearch";
import StatusFilter from "./controls/StatusFilter";
import BulkActions from "./controls/BulkActions";
import { ShieldAlert } from "lucide-react";

export default function Controls() {
    const { shortcodes, selectedItems, handleBulkActions } = useRulesContext();
    const { confirm, ConfirmDialog } = useConfirm();

    const handleEmptyTrash = async () => {
        const confirmed = await confirm(
            __(
                "Are you sure you want to empty the trash? This action cannot be undone.",
                "wpbean-quantity-controls-for-woocommerce",
            ),
            {
                title: __(
                    "Empty Trash?",
                    "wpbean-quantity-controls-for-woocommerce",
                ),
                type: "danger",
            },
        );
        if (confirmed) {
            handleBulkActions("empty_trash");
        }
    };

    // Check if all selected items are in the trash
    const allSelectedAreTrash =
        selectedItems.size > 0 &&
        Array.from(selectedItems).every((id) => {
            const item = shortcodes.find((s) => String(s.id) === String(id));
            return item && item.rule_status === "trash";
        });

    return (
        <div className="px-4 sm:px-6 py-5 sm:py-4 bg-gray-50 border-b border-gray-200">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 sm:gap-4 w-full sm:w-auto">
                    {/* Search */}
                    <ControlSearch />

                    {/* Status Filter */}
                    <StatusFilter />

                    {/* Bulk Actions */}
                    {selectedItems.size > 0 && <BulkActions />}
                </div>

                {/* Delete permanently the trash items */}
                {allSelectedAreTrash && (
                    <>
                        <button
                            onClick={() => handleEmptyTrash()}
                            className="px-4 py-2 bg-red-100 text-red-700 rounded-md hover:bg-red-200 transition-colors font-medium flex items-center justify-center gap-2 w-full sm:w-auto"
                        >
                            <ShieldAlert className="w-4 h-4" />
                            {__(
                                "Delete permanently",
                                "wpbean-quantity-controls-for-woocommerce",
                            )}
                        </button>
                        <ConfirmDialog />
                    </>
                )}
            </div>
        </div>
    );
}
